module.exports = __webpack_public_path__ + "static/media/social-vkontakte.ad2bf25c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/auth/social-vkontakte.svg
// module id = 116
// module chunks = 0